<template>
  <v-card
    :class="`change-address menu pa-6 text-start`"
    elevation="0">
    <template v-if="addresses.length">
      <v-card-title class="h5-headline text-start pa-0">
        {{ $t(`Tenders.SelectDeliveryAddress`) }}
      </v-card-title>
      <AdressesRadioList
        :addresses="addresses"
        :model.sync="choosed"
        title="title">
        <template #subtitle="{ item: itemAddress }">
          <span>
            {{ itemAddress.postalCode }}
            {{ $t('Common.City') }}{{ itemAddress.city }}
            {{ itemAddress.street }}
          </span>
        </template>
      </AdressesRadioList>
      <AddNewAddress
        :addresses="addresses"
        mode="tender"/>
    </template>
    <template v-else>
      <v-card-title class="h5-headline text-start pa-0">
        {{ $t(`Tenders.EnterDeliveryAddress`) }}
      </v-card-title>
      <AddresInputBlock
        :addresses="addresses"
        class="mt-4"
        :item.sync="new_address"
        mode="tender"/>
    </template>
    <v-card-actions class="flex-direction-column align-start px-0 mt-4">
      <span class="h5-headline ">{{ $t(`Tenders.ApplyAllItems`) }}</span>
      <v-radio-group
        v-model="for_all"
        class="mt-4"
        row>
        <v-radio
          class=" h7-text"
          color="var(--black-color)"
          :label="$t('Tenders.Yes')"
          :value="true"/>
        <v-radio
          class="ml-13 h7-text"
          color="var(--black-color)"
          :label="$t('Tenders.No')"
          :value="false"/>
      </v-radio-group>
      <sButton
        :disabled="disabled"
        @click="apply">
        {{ $t(`Common.Apply`) }}
      </sButton>
    </v-card-actions>
  </v-card>
</template>
<script>
import AddNewAddress from 'components/common/dialogs/AddNewAddress.vue'
import AddresInputBlock from 'components/common/blocks/AddresInputBlock.vue'
import AdressesRadioList from 'components/common/blocks/AdressesRadioList.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'changeLotAddres',
  data() {
    return {
      subtitle: '',
      title: '',
      // addresses: [],
      new_address: {},
      for_all: true,
      choosed: null
    }
  },
  props: {
    lots: Array,
    item: Object,
    addresses: Array,
    addr: [Number, String]
  },
  created() {
    this.choosed = this.addresses?.findIndex(el => el.supplierAddressId == this.item.addressId)
  },
  computed: {
    disabled() {
      return  !this.addresses.length ? (!this.new_address.city || !this.new_address.street_name) : typeof this.choosed != 'number'
    }
  },
  methods: {
    async createAddress() {
      await api.createSuppliersAddress({
        title: this.new_address.name,
        cityCode: this.new_address.city,
        streetType: this.new_address.street_type,
        street: this.new_address.street_name,
        house: this.new_address.house,
        apartment: this.new_address.flat,
        block: this.new_address.corps,
        postalCode: this.new_address.index
      })
        .then( res => {
          this.new_address = {}
          this.choosed = res.data.createSuppliersAddress
          this.$store.dispatch('setSupplierAddress', true)
        })
        .catch(error => this.$log_error(error) )
    },

    async apply() {
      if ((this.new_address.city && this.new_address.street_name) && !this.addresses.length) {
        await this.createAddress()
      }

      this.$emit('update:lots', this.lots.map( el => {
        if ((el.lotNumber == this.item.lotNumber) || this.for_all) {
          el.addressId = this.addresses[this.choosed].supplierAddressId
        }
        return el
      }))

      this.$emit('change')
      this.$emit('update:activ', false)
    }
  },
  components: {
    AddNewAddress,
    AddresInputBlock,
    AdressesRadioList
  }
}
</script>
<style lang="scss" scoped>
.change-address  {
  width: 456px;
}
</style>
